var carouselEvents = require('src/interlock/ui/owl-carousel/carousel-events');
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');

var $carousel = $('.at-a-glance-carousel-wrapper .owl-carousel');
var slides = {};
// move to constants
var defaultOffset = 5;

module.exports = {
    isSmall: function() {
        return responsiveToolkit.is('<=sm');
    },
    getCurrentSlideIndex: function() {
        return $carousel.find('.owl-item.active').index('.owl-item:not(.cloned)') - defaultOffset + 1;
    },
    getItems: function() {
        return $carousel.find('.owl-item:not(.cloned) .item');
    },
    backup: function(key) {
        slides[key] = this.getItems().clone();
    },
    restore: function(key) {
        var items = slides[key];
        if(items) {
            this.clear();
            items.map(function(index, item) {
                carouselEvents.addSlide($carousel, item);
            });
            carouselEvents.refresh($carousel);
            carouselEvents.changeSlide($carousel, defaultOffset, 85);
        }
    },
    clear: function() {
        this.getItems().map(function() {
            carouselEvents.removeSlide($carousel, 0);
        });
        carouselEvents.refresh($carousel);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-content.js
// module id = 142
// module chunks = 0 1 27